import { ServerError, ServerParseError } from '@apollo/client';
import { onError } from '@apollo/client/link/error';

import { removeToken } from '../common/auth';
import { appSnacksVar } from './app-snacks';

type NetworkErrorType = Error | ServerError | ServerParseError | undefined;

function getStatusCode(error: NetworkErrorType): number | undefined {
  if (!error) return;
  return 'statusCode' in error ? error.statusCode : undefined;
}

export default function createErrorLink(ssoUrl: string) {
  return onError((error) => {
    for (const err of error.graphQLErrors ?? []) {
      switch (err.extensions?.code) {
        case 'UNAUTHENTICATED':
          removeToken();
          localStorage.setItem('returnPath', JSON.stringify(window.location.pathname));
          window.location.assign(ssoUrl);
          return;
      }
    }

    if (error.networkError) {
      const statusCode = getStatusCode(error.networkError);
      if (statusCode === 504) {
        appSnacksVar([
          ...appSnacksVar(),
          {
            id: Date.now() + Math.random(),
            message:
              'Query did not complete due to a timeout. Please try a smaller date range',
            severity: 'warning',
          },
        ]);
      } else {
        appSnacksVar([
          ...appSnacksVar(),
          {
            id: Date.now() + Math.random(),
            message: `There was a network error and the query was canceled (code: ${
              statusCode ?? 'unknown'
            })`,
            severity: 'error',
          },
        ]);
      }
    }
  });
}
